module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_03-1c65337263a0d55fa15efd3dd66e2420.png";